import React from 'react'
import './MenuDropdownPost.scss'
import {graphql, useStaticQuery} from 'gatsby'
import ExternalLink from '../../Links/ExternalLink'
import {useI18next} from 'gatsby-plugin-react-i18next'

const MenuDropdownPost = ({menu}) => {
    const {language} = useI18next()

    const data = useStaticQuery(graphql`
        query {
            allStrapiMenuLink {
                edges {
                    node {
                        id
                        title
                        description
                        url
                        menu
                        order
                        locale
                    }
                }
            }
        }
    `)

    const localizedMenuLinks = data.allStrapiMenuLink.edges.filter(({node}) => node.locale === language)

    return (
        <div className="menu-dropdown-post__wrapper">
            {localizedMenuLinks.map(
                (menuLink) =>
                    menuLink.node.menu === menu && (
                        <ExternalLink
                            href={menuLink.node.url}
                            className={'navbar-item menu-dropdown-post__item'}
                            key={menuLink.node.id}
                        >
                            <div>{menuLink.node.title}</div>
                            <div className="menu-dropdown-post__item-description">{menuLink.node.description}</div>
                        </ExternalLink>
                    )
            )}
        </div>
    )
}

export default MenuDropdownPost
